import { useRouter } from "vue-router";
import { useToastStore } from "@S/toast";
import { useUserStore } from "@S/user";
import ApiRequest from "@L/ApiRequest";

export function useAuth() {
  const router = useRouter();
  const toastStore = useToastStore();
  const userStore = useUserStore();
  const signOut = async () => {
    try {
      const { data } = await ApiRequest().post("/logout");
      if (data?.message) {
        toastStore.show(data.message, "success");
        userStore.setUser(null);
        router.push({ name: "signin" });
      }
    } catch (e) {
      toastStore.show(e, "error");
    }
  };
  return { signOut };
}
